import { useAction } from '@sde/widgets-core/src/redux/hooks/useAction';
import { useSelect } from '@sde/widgets-core/src/redux/hooks/useSelect';
import { useAsync } from '@sde/widgets-core/src/redux/hooks/useAsync';
import { getPayers, setPayer } from './actions';
import { GET_PAYERS, SET_PAYER } from './constants';

const payersSelector = (state) => state.payers.list;

export const usePayers = {
  state: () => {
    const payers = useSelect(payersSelector);
    return { payers };
  },
  actions: () => {
    return {
      getPayers: useAction(getPayers, {
        saga: useAsync(GET_PAYERS),
      }),
      setPayer: useAction(setPayer, {
        saga: useAsync(SET_PAYER),
      }),
    };
  },
};
